import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { SET_PAGE, SET_ROWS_PER_PAGE } from '../../../redux/Table';
import PaginationComponent from './PaginationComponent';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';
class Pagination extends PureComponent {
  handleLimitSelect = (event) => {
    const { setRowsPerPage, tableName, fetchOffers } = this.props;
    const selection = event.target.value;
    setRowsPerPage({ tableName, rowsPerPage: parseInt(selection, 10) });
    fetchOffers();
  };

  handleNextPageClick = () => {
    const { setPage, tableName, page, totalPages, fetchOffers } = this.props;
    const isBelowMaxPage = page + 1 <= totalPages;
    if (isBelowMaxPage) {
      setPage({ tableName, page: page + 1 });
      fetchOffers();
    }
  };

  handlePrevPageClick = () => {
    const { setPage, tableName, page, fetchOffers } = this.props;
    const isAboveMinPage = page - 1 > 0;
    if (isAboveMinPage) {
      setPage({ tableName, page: page - 1 });
      fetchOffers();
    }
  };

  render() {
    const { rowsPerPage, totalCount, page, totalPages, t } = this.props;
    const isLastPage = totalPages === page;
    const isFirstPage = page === 1;
    const currentMin = page === 1 ? 1 : (page - 1) * rowsPerPage;
    const currentMax = page === totalPages ? totalCount : page * rowsPerPage;

    return (
      <PaginationComponent
        handleLimitSelect={this.handleLimitSelect}
        totalCount={totalCount}
        currentMin={currentMin}
        currentMax={currentMax}
        rowsPerPage={rowsPerPage}
        onNextClick={this.handleNextPageClick}
        onPrevClick={this.handlePrevPageClick}
        isLastPage={isLastPage}
        isFirstPage={isFirstPage}
      />
    );
  }
}

Pagination.propTypes = {
  t: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setRowsPerPage: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  fetchOffers: PropTypes.func.isRequired,
  tableName: PropTypes.string.isRequired,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  totalPages: PropTypes.number,
  totalCount: PropTypes.number,
};

Pagination.defaultProps = {
  page: 1,
  rowsPerPage: 20,
  totalCount: 0,
  totalPages: 1,
};

const mapStateToProps = (state, ownProps) => {
  return {
    page: get(state, ['tables', ownProps.tableName, 'page']),
    rowsPerPage: get(state, ['tables', ownProps.tableName, 'rowsPerPage']),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setPage: payload => dispatch(SET_PAGE(payload)),
  setRowsPerPage: payload => dispatch(SET_ROWS_PER_PAGE(payload)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('pagination')
)(Pagination);
